
<script>
export default {

    /** loading 加载 **/
    open(title) {
        let showtitle=title ? title : '数据正在加载中，请稍等......';
        document.getElementById('TTLloadingtitle').textContent=showtitle; //显示标签
        document.getElementById('TTLloadingbox').style.display="inline-flex";
        setTimeout(function() { //延时加载显示
            document.getElementById('TTLloadingbox').style.opacity=1; //显示loading
        },100);
    },

    /** loading 关闭 **/
    close() {
        document.getElementById('TTLloadingbox').style.opacity=0; //关闭loading
        setTimeout(function() { //关闭loading
            document.getElementById('TTLloadingbox').style.display="none";
        },100);
    },


    /** v-loading 加载 **/
    openloading(mainobj) {
        let loadingobj=document.getElementById('TTLloadingbox2');
        mainobj.append(loadingobj.cloneNode(true));
        mainobj.querySelector("#TTLloadingbox2").style.display='inline-flex';
        // mainobj.style.overflow='hidden';
        setTimeout(function() { //延时加载显示
            mainobj.querySelector('#TTLloadingbox2').style.opacity=1; //显示loading
        },200);
    },


    /** v-loading 删除 **/
    closeloading(mainobj) {
        mainobj.querySelector('#TTLloadingbox2').style.opacity=0;
        setTimeout(function() { //延时加载显示
            mainobj.querySelector("#TTLloadingbox2").remove();
        },200);
    },

}
</script>